import classNames from 'classnames';
import { IconV1 } from 'common/icon/iconV1.js';
import { CSSProperties } from 'react';
import { LegendsEnum } from './legend-types.js';

interface LegendActionProps {
  label: string;
  onClick: (l: LegendsEnum) => void;
  // has specific action been selected
  active: LegendsEnum | undefined;
  icon: 'key' | 'filter';
  index: LegendsEnum;
}

export const LegendHeaderAction = ({ label, onClick, active, icon, index }: LegendActionProps) => {
  const activeWidth: CSSProperties['width'] = active ? '130px' : '100%';
  return (
    <div
      className={classNames('u-flexJustifyCenter u-flex', { 'is-active border-bottom-active': active === index })}
      style={{ width: '100%' }}
    >
      <div
        aria-label={label}
        onClick={() => onClick(index)}
        className={classNames('u-flex u-textCenter', { 'is-active border-bottom-active': active === index })}
        style={{
          cursor: 'pointer',
          width: activeWidth,
        }}
      >
        <div className="u-textBold u-text-sm u-flexInline Legend-action-button">
          <IconV1 icon={icon} size={24} iconClass="u-flex-1" />
          <span className={classNames({ 'u-hidden': !active }, 'u-pL-xs u-lg-displayInherit u-flex-1')}>{label}</span>
        </div>
      </div>
    </div>
  );
};
